/**
 * IMPORTS
 */
import {gql} from '@apollo/client';


/**
 * EXPORTS
 */
export const FETCH_BSUID = gql`
query bsuid ($channel: String!, $uid: String!) {
    bsuid (channel: $channel, uid: $uid) {
        bsuid
        uid
        username
    }
}`;

export const FETCH_BSUIDS_BY_UID = gql`
query bsuidsByUid ($channel: String!, $uids: [String!]!) {
    bsuidsByUid (channel: $channel, uids: $uids) {
        bsuid
        uid
        username
    }
}`;

export const FETCH_COMPANY_CONTACTS = gql`
query companyContacts ($limit: Int!, $search: String!) {
    companyContacts (limit: $limit, search: $search) {
        channel
        id
        uid
    }
}
`;

export const FETCH_CONTACT_TYPES = gql`
query ContactTypes {
    contactTypes {
        channel
        id
        name
        prefix
    }
}`;

export const FETCH_CUSTOMER_BY_CONTACT = gql`
query customerByContact($channel: String!, $company: Int!, $uid: String!) {
    customerByContact(channel: $channel, company: $company, uid: $uid) {
        address1
        address2
        agents {
            uid
        }
        city
        code
        contacts {
            channel
            id
            uid
            username
        }
        description
        document
        id
        name
        organization
        state
        tags {
            id
            tag
        }
        zipcode
    }
}`;

export const FETCH_CUSTOMERS = gql`
query Customer ($filters: CustomersFilters) {
    customers(filters: $filters) {
        agents {
            uid
        }
        address1
        address2
        city
        code
        company
        contacts {
            channel
            id
            name
            uid
            username
        }
        description
        document
        email
        id
        name
        organization
        tags {
            id
            tag
        }
        state
        zipcode
    }
}`;

export const FETCH_CUSTOMERS_BY_COMPANY = gql`
query CustomersByCompany ($company: Int!) {
    customersByCompany(company: $company) {
        agents {
            uid
        }
        address1
        address2
        city
        code
        company
        contacts {
            channel
            id
            uid
            username
        }
        description
        document
        email
        id
        name
        organization
        state
        tags {
            id
            tag
        }
        zipcode
    }
}`;

export const FETCH_CUSTOMERS_BY_TAG_PAGE = gql`
query TagCustomersPage ($tag: Int!, $page: Int!, $size: Int) {
    customers: tagCustomersPage(tag: $tag, page: $page, size: $size)
}
`;

export const FETCH_CUSTOMERS_BY_TAGS = gql`
query CustomersByTags ($company: Int!, $tags: [Int!]!) {
    customersByTags(company: $company, tags: $tags) {
        agents {
            uid
        }
        address1
        address2
        city
        code
        company
        contacts {
            channel
            id
            uid
            username
        }
        description
        document
        email
        id
        name
        organization
        state
        tags {
            id
            tag
        }
        zipcode
    }
}
`;

export const FETCH_CUSTOMERS_PAGE = gql`
query customersPage($company: Int!, $page: Int!, $size: Int) {
    customersPage(company: $company, page: $page, size: $size) {
        id
        agents {
            uid
        }
        contacts {
            channel
            id
            uid
            username
        }
        name
        organization
        tags {
            id
            tag
        }
    }
}
`;

export const FETCH_WHATSAPP_CONTACT = gql`
query WhatsappContact ($account: String!, $contact: String!) {
    whatsappContact(account: $account, contact: $contact)
}`;

export const FETCH_WHATSAPP_CONTACT_STATUS = gql`
query whatsappContactStatus ($account: String!, $contact: String!) {
    status: whatsappContactStatus (account: $account, contact: $contact) {
        __typename
        ...on WhatsappContactStatus {
            blocked
        }
        ...on Error {
            code
            info
        }
    }
}`;

export const FETCH_CUSTOMER = gql`
query CustomerById($id: Int!) {
    customer(id: $id) {
        agents {
            uid
        }
        address1
        address2
        city
        code
        company
        contacts {
            channel
            id
            uid
            username
        }
        description
        document
        email
        id
        name
        organization
        state
        tags {
            id
            tag
        }
        zipcode
    }
}
`;
